import { Image, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { crmUploadUrl } from '../utils/crmUploadUrl';

type Props = {
  fileUrl: string;
  alt: string;
};

export function CrmDriverDocumentImage({ fileUrl, alt }: Props) {
  const src = useMemo(() => crmUploadUrl(fileUrl), [fileUrl]);
  const [failed, setFailed] = useState(false);

  if (!src) {
    return <Typography.Text type="secondary">無法取得圖片網址</Typography.Text>;
  }

  if (failed) {
    return (
      <Typography.Text type="secondary">
        瀏覽器無法預覽此圖（可能為 HEIC 等格式）。{' '}
        <a href={src} target="_blank" rel="noreferrer">
          在新分頁開啟／下載
        </a>
      </Typography.Text>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      style={{ maxWidth: '100%', borderRadius: 12 }}
      onError={() => setFailed(true)}
      preview={{ src }}
    />
  );
}
